<template>

    <div>

        <div id="side-popup-bg" role="close-side-popup" class="fixed left-0 top-0 w-full h-full bg-black/40 z-[1001] opacity-0 pointer-events-none transition-all !duration-500" :class="show && '!opacity-100 !pointer-events-auto'" @click="closeSidePopup"></div>

        <div class="fixed left-full lg:left-full top-0 h-full bg-white w-full max-w-[calc(100%-2rem)] md:max-w-[45rem] lg:max-w-[60rem] xl:max-w-[60rem] 2xl:max-w-[60rem] z-[1002] transition-all !duration-500 opacity-0 pointer-events-none" :class="show && '!-translate-x-full !opacity-100 !pointer-events-auto'">

            <div class="absolute left-0 top-0 w-[21rem] h-[13rem] pointer-events-none hidden xl:block">
                <div class="absolute top-0 left-0 w-full h-full bg-[url('/images/illustrazioni/decorazioni/pianta-2.svg')] !bg-right-bottom !bg-no-repeat !bg-cover"></div>
            </div>

            <button @click="closeSidePopup" role="close-side-popup" type="button" class="absolute left-0 -translate-y-1/2 -translate-x-1/2 flex w-auto h-auto top-14 sm:top-14 md:top-16 lg:top-20 xl:top-24 2.5xl:top-28 group !rounded-full overflow-hidden shadow-xl z-[100]">
                <span class="relative w-9 h-9 sm:w-11 sm:h-11 md:w-12 md:h-12 lg:w-13 lg:h-13 rounded-full block group-hover:rotate-90 transition-all !duration-500">
                    <img alt="icona" src="/images/illustrazioni/x.svg" width="50" height="50" class="w-full h-full"/>
                </span>
            </button>

            <div class="w-full h-full flex flex-col xl:justify-center gap-y-12 xl:gap-y-12 2.5xl:gap-y-14 relative overflow-y-scroll overflow-x-hidden px-7 py-12 sm:py-14 md:py-16 md:px-18 lg:p-20 xl:px-24 xl:py-20 2.5xl:py-24 2.5xl:px-28">

                <div class="w-full flex flex-col">
                    <h2 class="text-black text-4xl sm:text-4.5xl md:text-5xl lg:text-5xl xl:text-6xl font-medium  relative mb-6 text-center lg:text-left">                        
                        {{$root.translateString('visit-popup-title')}}
                    </h2>

                    <h3 class="text-customGray-text text-xs sm:text-sm xl:text-xs tracking-[.12rem] font-medium text-center lg:text-left">
                        {{$root.translateString('visit-popup-subtitle')}}
                    </h3>
                </div>

                <visit-form :lang="lang" />

            </div>

        </div>

    </div>

</template>

<script>
    export default {
        props: ['content', 'lang'],
        data() {
            return {
                show: false
            }
        },
        mounted() {

            window.addEventListener('showVisitsPopup', (event) => {
                this.show = true;
            })

        },

        methods: {
            closeSidePopup() {
                this.show = false;
                const event = new CustomEvent('closeVisitsPopup', {});
                dispatchEvent(event)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
